module.exports = __webpack_public_path__ + "static/media/D.1563af11.jpg";